export const baseURL = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : "https://sctc-backend-945132838807.us-central1.run.app/";

export const loginUrl = "accounts/login/";
export const logoutUrl = "accounts/logout/";
export const UserUrl = "accounts/user/";
export const refreshTokenUrl = "accounts/refresh/";
export const createUser = "accounts/create-user/";
export const user = "accounts/user/";
export const loggedInUser = "accounts/user/me/";

// patient
export const patient = "clinic/patient/";
export const document = "clinic/document/";
export const bulkDeleteDocument = "clinic/documents/bulk-delete/";
export const documentType = "clinic/document-types/";
export const patientDashboard = "clinic/patient-dashboard/";
